import { ActivityIndicator, StyleSheet, Text, View } from "react-native"

interface LoadingProps {
  message?: string
}

export const Loading = ({ message }: LoadingProps) => {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" />
      {message ? <Text style={styles.message}>{message}</Text> : null}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  message: {
    marginTop: 8,
    textAlign: "center",
    fontSize: 12,
    color: "#888",
  },
})
